// extracted by mini-css-extract-plugin
export default {"content":"styles_content__Nr-IA","title":"styles_title__BLqz4","list":"styles_list__-qiAV","item":"styles_item__YRh01"};